<template>
    <div data-testid="visit-medical-report-page">
                <medical-report></medical-report>
        </div>
</template>

<script>
  // import { mapState, mapActions } from 'vuex'
  import apiMixin from '@/mixins'
  import MedicalReport from './MedicalReportNew.vue'

  export default {
    data () {
      return {
        //
      }
    },
    mixins: [apiMixin],
    methods: {
      //
    },
    beforeMount () {
      //
    },
    watch: {
      //
    },
    components: {
      MedicalReport
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Visit/components/VisitMedicalReport.vue?7e26f89c